import { useTranslation } from 'react-i18next';
import { useNavigate } from '@tanstack/react-router';
import { IconButton, Loader } from 'app/components';
import { useLists } from 'entities/list';

interface ListSummary {
  id: number;
  code: string;
  name: string;
}

const Lists = () => {
  const { t } = useTranslation('lists');

  const lists = useLists();
  const navigate = useNavigate();

  function handleListClick(list: ListSummary) {
    navigate({ to: '/admin/lists/$id', params: { id: list?.code } });
  }

  function handleNewClick() {
    navigate({ to: '/admin/lists/new' });
  }

  function renderContent() {
    if (lists?.isLoading || !lists.data) {
      return <Loader />;
    }

    return (
      <table>
        <thead>
          <tr>
            <th>{t('code')}</th>
            <th>{t('name')}</th>
          </tr>
        </thead>
        <tbody>
          {(lists.data as ListSummary[]).map((item) => {
            return (
              <tr key={item.id} onClick={() => handleListClick(item)}>
                <td>{item.code}</td>
                <td>{item.name}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }

  return (
    <>
      <div className="content-title columns two mb-2">
        <h1 className="">{t('title')}</h1>
        <div className="justify-self-end">
          <IconButton onClick={handleNewClick} icon="plus" />
        </div>
      </div>
      {renderContent()}
    </>
  );
};

export default Lists;
